(function () {
  'use strict';

  function init() {
    var bar = document.querySelector('[data-zen-sticky-atc]');
    if (!bar) return;

    var formId = bar.getAttribute('data-form-id');
    var mainSubmit = document.querySelector(
      'product-form #ProductSubmitButton-' +
        (bar.id ? bar.id.replace('ZenStickyATC-', '') : '')
    );

    // Fallback: grab the first product-form submit button on the page.
    if (!mainSubmit) {
      mainSubmit = document.querySelector('product-form .product-form__submit');
    }

    var mainButtonsWrap = mainSubmit
      ? mainSubmit.closest('.product-form__buttons') || mainSubmit
      : null;

    // Prefer the theme footer; fall back to any .sb-footer / .zen-footer.
    var footer =
      document.querySelector('footer.footer') ||
      document.querySelector('.shopify-section-group-footer-group footer') ||
      document.querySelector('.sb-footer') ||
      document.querySelector('.zen-footer');

    if (!mainButtonsWrap) {
      // Nothing to observe — leave the bar hidden.
      return;
    }

    var mainButtonsOut = false;
    var footerIn = false;

    var updateVisibility = function () {
      var shouldShow = mainButtonsOut && !footerIn;
      bar.classList.toggle('is-visible', shouldShow);
      bar.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
    };

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(
        function (entries) {
          var entry = entries[0];
          // Only show sticky when the main ATC is scrolled PAST (above viewport),
          // not when user is still above it and hasn't reached it yet.
          mainButtonsOut = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          updateVisibility();
        },
        { threshold: 0, rootMargin: '0px 0px -20px 0px' }
      ).observe(mainButtonsWrap);

      if (footer) {
        new IntersectionObserver(
          function (entries) {
            footerIn = entries[0].isIntersecting;
            updateVisibility();
          },
          { threshold: 0 }
        ).observe(footer);
      }
    } else {
      // Very old browsers: fall back to a simple scroll check.
      var onScroll = function () {
        var rect = mainButtonsWrap.getBoundingClientRect();
        mainButtonsOut = rect.bottom < 0;
        if (footer) {
          var frect = footer.getBoundingClientRect();
          footerIn = frect.top < window.innerHeight;
        }
        updateVisibility();
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      onScroll();
    }

    // Wire the sticky button to submit the main product form.
    var stickyBtn = bar.querySelector('[data-zen-sticky-atc-submit]');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function (event) {
        event.preventDefault();

        // Re-query in case variant changed and button was replaced.
        var currentSubmit = document.querySelector(
          '#ProductSubmitButton-' +
            (bar.id ? bar.id.replace('ZenStickyATC-', '') : '')
        );
        if (!currentSubmit) {
          currentSubmit = document.querySelector('product-form .product-form__submit');
        }
        if (!currentSubmit || currentSubmit.disabled) return;

        stickyBtn.classList.add('is-loading');
        currentSubmit.click();

        // Remove loading state shortly after; the theme's cart notification
        // / drawer will take over feedback from here.
        window.setTimeout(function () {
          stickyBtn.classList.remove('is-loading');
        }, 1200);
      });
    }

    // Keep sticky button state in sync with the main submit (sold out, etc.).
    var syncDisabled = function () {
      if (!stickyBtn) return;
      var currentSubmit = document.querySelector(
        '#ProductSubmitButton-' +
          (bar.id ? bar.id.replace('ZenStickyATC-', '') : '')
      );
      if (!currentSubmit) return;
      stickyBtn.disabled = currentSubmit.disabled;
      var label = stickyBtn.querySelector('.zen-sticky-atc__button-label');
      var mainLabel = currentSubmit.querySelector('span');
      if (label && mainLabel && mainLabel.textContent.trim()) {
        label.textContent = mainLabel.textContent.trim();
      }
    };

    // Sync sticky button state on variant changes via theme's pub/sub.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function () {
        // Defer to next tick so DOM swap completes first.
        setTimeout(syncDisabled, 0);
        setTimeout(syncPrice, 0);
      });
    }
    syncDisabled();

    var sectionId = bar.id ? bar.id.replace('ZenStickyATC-', '') : '';
    var stickyCurrent = bar.querySelector('.zen-sticky-atc__price-current');
    var stickyCompare = bar.querySelector('.zen-sticky-atc__price-compare');

    var variants = [];
    var plans = [];
    try {
      var vn = document.querySelector('[data-zen-sticky-variants="' + sectionId + '"]');
      if (vn) variants = JSON.parse(vn.textContent || '[]');
      var pn = document.querySelector('[data-zen-sticky-plans="' + sectionId + '"]');
      if (pn) plans = JSON.parse(pn.textContent || '[]');
    } catch (e) { /* noop */ }

    var moneyFormat = bar.getAttribute('data-money-format') || '${{amount}}';
    var defaultVariantId = parseInt(bar.getAttribute('data-current-variant'), 10) || (variants[0] && variants[0].id);

    function formatMoney(cents) {
      if (typeof cents !== 'number' || isNaN(cents)) return '';
      var amount = (cents / 100).toFixed(2);
      var amountNoDec = Math.round(cents / 100).toString();
      var amountWithComma = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      var amountNoDecWithComma = amountNoDec.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return moneyFormat
        .replace(/\{\{\s*amount\s*\}\}/g, amountWithComma)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amountNoDecWithComma)
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace('.', ','))
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, amountNoDec);
    }

    function getSelectedVariantId() {
      var form = document.querySelector('product-form form[id="' + (bar.getAttribute('data-form-id') || '') + '"]') ||
                 document.querySelector('product-form form');
      if (form) {
        var idEl = form.querySelector('[name="id"]');
        if (idEl && idEl.value) return parseInt(idEl.value, 10);
      }
      return defaultVariantId;
    }

    function getSelectedPlanId() {
      var checked = document.querySelector('input[name="selling_plan"]:checked, input[name="selling-plan"]:checked');
      if (checked && checked.value) return parseInt(checked.value, 10);
      var sel = document.querySelector('select[name="selling_plan"], select[name="selling-plan"]');
      if (sel && sel.value) return parseInt(sel.value, 10);
      var hidden = document.querySelector('input[name="selling_plan"][type="hidden"], input[name="selling-plan"][type="hidden"]');
      if (hidden && hidden.value) return parseInt(hidden.value, 10);
      return 0;
    }

    function applyPlan(priceCents, plan) {
      if (!plan) return priceCents;
      var val = Number(plan.value) || 0;
      if (plan.value_type === 'percentage') {
        return Math.round(priceCents * (100 - val) / 100);
      }
      if (plan.value_type === 'fixed_amount') {
        return Math.max(0, priceCents - val);
      }
      if (plan.value_type === 'price') {
        return val;
      }
      return priceCents;
    }

    function syncPrice() {
      if (!variants.length || !stickyCurrent) return;
      var vid = getSelectedVariantId();
      var variant = null;
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].id === vid) { variant = variants[i]; break; }
      }
      if (!variant) variant = variants[0];
      if (!variant) return;

      var planId = getSelectedPlanId();
      var plan = null;
      if (planId) {
        for (var j = 0; j < plans.length; j++) {
          if (plans[j].id === planId) { plan = plans[j]; break; }
        }
      }

      var finalCents = applyPlan(variant.price, plan);
      stickyCurrent.textContent = formatMoney(finalCents);

      if (stickyCompare) {
        var showCompare = false;
        var compareText = '';
        if (plan) {
          showCompare = true;
          compareText = formatMoney(variant.price);
        } else if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          showCompare = true;
          compareText = formatMoney(variant.compare_at_price);
        }
        stickyCompare.textContent = showCompare ? compareText : '';
        stickyCompare.style.display = showCompare ? '' : 'none';
      }
    }

    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t) return;
      var name = t.name || t.getAttribute && t.getAttribute('name') || '';
      if (name === 'selling_plan' || name === 'selling-plan' || name === 'id' ||
          /selling[-_]plan/i.test(name) || (t.closest && t.closest('[data-appstle], .appstle_subscription_wrapper'))) {
        setTimeout(syncPrice, 30);
        setTimeout(syncPrice, 250);
        setTimeout(syncPrice, 800);
      }
    });
    document.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('[data-appstle], .appstle_subscription_wrapper, .appstle-subscription-wrapper')) {
        setTimeout(syncPrice, 50);
        setTimeout(syncPrice, 300);
        setTimeout(syncPrice, 900);
      }
    });

    var appstleRoot = document.querySelector('.appstle_subscription_wrapper, .appstle-subscription-wrapper, [data-appstle]');
    if (appstleRoot && 'MutationObserver' in window) {
      new MutationObserver(function () { setTimeout(syncPrice, 30); })
        .observe(appstleRoot, { childList: true, subtree: true, attributes: true });
    }

    var lastSig = '';
    function checkAndSync() {
      var vid = getSelectedVariantId();
      var pid = getSelectedPlanId();
      var sig = vid + '|' + pid;
      if (sig !== lastSig) {
        lastSig = sig;
        syncPrice();
      }
    }

    if ('MutationObserver' in window) {
      new MutationObserver(checkAndSync).observe(document.body, {
        childList: true, subtree: true, attributes: true,
        attributeFilter: ['checked', 'value', 'selected', 'data-selling-plan', 'data-plan-id', 'class']
      });
    }

    [100, 300, 600, 1000, 1500, 2500, 4000, 6000, 9000].forEach(function (ms) {
      setTimeout(checkAndSync, ms);
    });

    window.addEventListener('load', function () { setTimeout(checkAndSync, 100); });

    syncPrice();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
